import PropTypes from 'prop-types';

import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';

export function HostingAndEntertaining({ brand, isActive, width }) {
    const activeColor = brand === MISFITS_THEME_DOMAIN ? '#D7E1B8' : '#F0D3E3';
    const plateColor = brand === MISFITS_THEME_DOMAIN ? '#F0C256' : '#F7D46D';
    const spoonColor = brand === MISFITS_THEME_DOMAIN ? '#DC6B31' : '#F6A685';
    const appleColor = brand === MISFITS_THEME_DOMAIN ? '#B22624' : '#D9291F';
    const leafColor = brand === MISFITS_THEME_DOMAIN ? '#2E8540' : '#547420';
    const cheeseColor = brand === MISFITS_THEME_DOMAIN ? '#F2EBD1' : '#ECE7E4';
    const grapesColor = brand === MISFITS_THEME_DOMAIN ? '#B0C472' : '#C5DB66';

    return isActive ? (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6505 28.7652C21.902 26.9646 29 22.6358 29 14.9992C29 7.3625 22.9452 2.7363 14.6505 1.1728C7.31233 -0.213857 2.48978 6.96057 1.13553 14.967C-0.132106 22.475 7.73356 30.4815 14.6505 28.7652Z"
                fill={activeColor}
            />
            <path
                d="M23.0001 10.2909V11.0126C22.3596 11.2045 21.6541 11.2825 20.8543 11.224C20.8738 10.9541 20.8478 10.7135 20.7697 10.538C20.7177 10.4177 20.6234 10.3006 20.5617 10.1803C20.3016 9.67637 20.5031 9.30573 20.6722 8.87331C20.6787 8.85705 20.6852 8.8408 20.6917 8.82129H21.5305C22.3369 8.82129 23.0001 9.48455 23.0001 10.2909Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.908 8.82129C19.8202 9.20494 19.7292 9.55283 19.2935 9.78041C19.1732 9.84219 19.0302 9.88771 18.9164 9.95598C18.6628 10.112 18.4254 10.4567 18.2466 10.8728C17.1087 10.8468 16 11.0126 16 11.0126V10.2909C16 9.48455 16.6633 8.82129 17.4696 8.82129H19.908Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23 11.0122V17.7326C23 18.5422 22.3367 19.2022 21.5304 19.2022H17.4696C16.6633 19.2022 16 18.5422 16 17.7326V11.0122C16 11.0122 17.1087 10.8464 18.2466 10.8724C17.8987 11.669 17.7622 12.7289 18.1426 13.2296C18.3117 13.4507 18.5295 13.6002 18.7668 13.6717C19.0042 13.7465 19.2675 13.753 19.5309 13.6652C20.2397 13.4377 20.8021 12.1534 20.8542 11.2235C21.654 11.2821 22.3595 11.204 23 11.0122Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.246 7.51123C20.1126 8.00868 20.0054 8.42484 19.9501 8.64918C19.9338 8.7077 19.9208 8.76622 19.9078 8.82474H16.9524C16.5883 8.82474 16.2957 8.52888 16.2957 8.16799C16.2957 7.98917 16.3704 7.82335 16.4875 7.70306C16.6045 7.58601 16.7703 7.51123 16.9524 7.51123H20.246Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.7074 8.16457C22.7074 8.34339 22.6327 8.5092 22.5156 8.6295C22.3953 8.74655 22.2295 8.82133 22.0507 8.82133H20.6917C20.7957 8.55147 20.9745 8.07028 21.1761 7.50781H22.0507C22.4116 7.50781 22.7074 7.80368 22.7074 8.16457Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.3924 4.04853C22.2169 4.6045 21.6316 6.25615 21.1764 7.50789H20.2466C20.5945 6.19762 21.1147 4.30213 21.3 3.70715C21.3 3.70715 21.4626 2.82605 22.1128 3.03088C22.7598 3.23571 22.3924 4.04853 22.3924 4.04853Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.1762 7.51123C20.9746 8.0737 20.7958 8.55489 20.6918 8.82474H19.9082C19.9212 8.76622 19.9342 8.7077 19.9505 8.64918C20.0057 8.42484 20.113 8.00868 20.2463 7.51123H21.1762Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8541 11.224C20.4282 11.1947 19.9795 11.1232 19.4983 11.0126C19.1179 10.9249 18.679 10.8826 18.2466 10.8728C18.4254 10.4567 18.6627 10.112 18.9163 9.95598C19.0301 9.88771 19.1732 9.84219 19.2935 9.78041C19.7292 9.55283 19.8202 9.20494 19.908 8.82129H20.6915C20.685 8.8408 20.6785 8.85705 20.672 8.87331C20.503 9.30573 20.3014 9.67637 20.5615 10.1803C20.6233 10.3006 20.7175 10.4177 20.7696 10.538C20.8476 10.7135 20.8736 10.9541 20.8541 11.224Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8542 11.2237C20.8022 12.1536 20.2398 13.4378 19.531 13.6654C19.2676 13.7532 19.0043 13.7467 18.7669 13.6719C18.5296 13.6004 18.3117 13.4508 18.1427 13.2297C17.7623 12.729 17.8988 11.6691 18.2467 10.8726C18.6791 10.8823 19.1181 10.9246 19.4985 11.0124C19.9796 11.1229 20.4283 11.1944 20.8542 11.2237Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.1504 10.158C13.3857 10.1952 13.6329 10.2464 13.8084 10.4279L13.8124 10.4325C15.7944 12.4428 14.8093 15.0626 14.3069 15.9514C13.8004 16.8029 13.5651 17.9802 12.9231 18.6829C12.3368 19.3297 11.2082 19.5298 10.4346 19.5298C9.11059 19.5298 8.15348 18.9249 7.23227 17.8965C6.73777 17.3474 6.67396 17.2962 6.39481 16.5005C6.17946 15.9328 6.04786 15.3278 6 14.7089V13.4386C6.02792 13.0384 6.11166 12.6475 6.24725 12.2752C6.53438 11.5772 6.62212 11.5772 7.08472 11.1212C8.15348 10.0603 9.00291 9.52979 10.4346 9.52979C10.5781 9.52979 10.7217 9.54375 10.8613 9.57167L13.0547 10.1673L13.1504 10.158Z"
                fill={appleColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M11.0417 10.9953H12C12.2771 10.9813 12.5542 10.9112 12.8032 10.785C13.0522 10.6589 13.2729 10.4813 13.4467 10.2664C14.1513 9.3785 13.9822 8 13.9822 8C12.0141 8 11.3236 8.91122 11.0981 9.72897C10.99 10.1449 10.9713 10.5748 11.0417 11V10.9953Z"
                fill={leafColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28 22.0649V24.0396C28 25.6728 22.1794 27 15.0014 27C7.82344 27 2 25.6728 2 24.0396V22.0649C2 21.2595 3.40666 20.5347 5.68741 20H24.3155C26.5933 20.5347 28 21.2595 28 22.0649Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28 22C28 22.3526 27.7395 22.6888 27.259 23.0022C25.4732 24.1676 20.6599 25 15.0014 25C9.34298 25 4.52388 24.1676 2.74096 23.0022C2.26049 22.6888 2 22.3493 2 22C2 21.1839 3.40666 20.4494 5.68741 19.9075C8.04631 19.3493 11.3488 19 15.0014 19C18.6541 19 21.9537 19.3493 24.3155 19.9075C26.5933 20.4494 28 21.1839 28 22Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.8799 17.2632V20.8455C24.8799 21.3632 24.4244 21.8395 23.6582 22.2211V18.6387C24.4244 18.2571 24.8799 17.7809 24.8799 17.2632Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.9315 22.7979L15.8872 22.789C14.1566 22.3926 13 21.6709 13 20.8455V17.2632C13 17.9939 13.9052 18.6417 15.3103 19.0558C15.4997 19.112 15.7008 19.1623 15.9079 19.2097C17.4195 19.5587 18.2803 20.0261 19.1767 20.0261H19.1855"
                fill={cheeseColor}
            />
            <path
                d="M15.9315 22.7979L15.8872 22.789C14.1566 22.3926 13 21.6709 13 20.8455V17.2632C13 17.9939 13.9052 18.6417 15.3103 19.0558C15.4997 19.112 15.7008 19.1623 15.9079 19.2097C17.4195 19.5587 18.2803 20.0261 19.1767 20.0261H19.1855"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.88 17.263C24.88 17.7807 24.4244 18.2569 23.6583 18.6385L19.0642 17.266L19.7032 19.0882L20.4191 19.458C19.9458 19.5053 19.6855 20.0259 19.1767 20.0259C18.1058 20.0259 16.8811 19.5171 15.3103 19.0556C13.9052 18.6415 13 17.9937 13 17.263C13 16.9228 13.1982 16.5974 13.5561 16.3075C14.4998 15.5354 16.5557 15 18.94 15C19.5376 15 20.1144 15.0325 20.6587 15.0947C23.1021 15.3786 24.88 16.2424 24.88 17.263Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.0643 20.8455L15.9316 22.7979L15.8872 22.8068V19.2244L15.9079 19.2097L19.0643 17.2632"
                fill="white"
            />
            <path
                d="M19.0643 20.8455L15.9316 22.7979L15.8872 22.8068V19.2244L15.9079 19.2097L19.0643 17.2632"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.0642 17.2632L23.6582 18.6387V22.2211L19.0642 20.8455V17.2632Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.50638 8.74777L7.06119 10.0008L8.16725 9.194C8.45142 8.98436 8.80519 9.34109 8.60031 9.62764L7.79751 10.734L9.04594 11.2908C9.3703 11.4355 9.23864 11.9223 8.88772 11.8828L7.52645 11.7372L7.67248 13.0997C7.70803 13.4514 7.22624 13.5805 7.08119 13.2582L6.52638 12.0051L5.42031 12.8119C5.13615 13.0216 4.78237 12.6648 4.98725 12.3783L5.79006 11.2719L4.54162 10.7152C4.21727 10.5704 4.34893 10.0836 4.69984 10.1231L6.06112 10.2688L5.91509 8.9062C5.87954 8.55451 6.36132 8.42542 6.50638 8.74777Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.98409 15.0948L2.98416 16.0949C2.98416 16.0949 5.43439 15.8724 7.98413 20.0947L8.24316 19.7346C8.24316 19.7346 6.98411 15.5948 2.98409 15.0948Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.82815 17.4973L7.76937 17.3175C8.03896 17.2517 8.29802 17.1308 8.51888 16.9602C8.73974 16.7895 8.92326 16.5737 9.05364 16.33C9.57911 15.3257 9.15433 14.0034 9.15433 14.0034C7.22114 14.3727 6.7139 15.3973 6.64588 16.2428C6.61781 16.6716 6.68003 17.0974 6.82903 17.5019L6.82815 17.4973Z"
                fill={leafColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.9284 25.8224C15.4759 25.2748 15.4254 24.3364 14.8154 23.7265C14.2054 23.1165 13.2671 23.0659 12.7195 23.6135C12.1719 24.1611 12.2225 25.0994 12.8325 25.7094C13.4424 26.3194 14.3808 26.3699 14.9284 25.8224Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7487 23.7267C15.2962 23.1791 15.2457 22.2407 14.6357 21.6308C14.0258 21.0208 13.0874 20.9702 12.5398 21.5178C11.9922 22.0654 12.0428 23.0037 12.6528 23.6137C13.2627 24.2237 14.2011 24.2742 14.7487 23.7267Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9577 18.1388C12.5052 17.5912 12.4547 16.6528 11.8447 16.0429C11.2347 15.4329 10.2964 15.3823 9.7488 15.9299C9.20122 16.4775 9.25179 17.4159 9.86175 18.0258C10.4717 18.6358 11.4101 18.6863 11.9577 18.1388Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.6862 19.9903C14.2337 19.4428 14.1832 18.5044 13.5732 17.8944C12.9633 17.2845 12.0249 17.2339 11.4773 17.7815C10.9297 18.3291 10.9803 19.2674 11.5903 19.8774C12.2002 20.4873 13.1386 20.5379 13.6862 19.9903Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.973 21.8487C14.5206 21.3012 14.47 20.3628 13.8601 19.7528C13.2501 19.1429 12.3118 19.0923 11.7642 19.6399C11.2166 20.1874 11.2672 21.1258 11.8771 21.7358C12.4871 22.3457 13.4255 22.3963 13.973 21.8487Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.95277 23.7267C10.5003 23.1791 10.4498 22.2407 9.83982 21.6308C9.22986 21.0208 8.29149 20.9702 7.74392 21.5178C7.19634 22.0654 7.24691 23.0037 7.85687 23.6137C8.46683 24.2237 9.40519 24.2742 9.95277 23.7267Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.432 24.5904C12.9796 24.0429 12.929 23.1045 12.3191 22.4945C11.7091 21.8846 10.7707 21.834 10.2232 22.3816C9.67559 22.9291 9.72616 23.8675 10.3361 24.4775C10.9461 25.0874 11.8844 25.138 12.432 24.5904Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.95057 18.6959C10.4981 18.1483 10.4476 17.21 9.83762 16.6C9.22766 15.99 8.28929 15.9395 7.74172 16.487C7.19414 17.0346 7.24471 17.973 7.85467 18.5829C8.46463 19.1929 9.403 19.2435 9.95057 18.6959Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8676 20.1041C12.4151 19.5565 12.3646 18.6182 11.7546 18.0082C11.1447 17.3982 10.2063 17.3477 9.65871 17.8952C9.11113 18.4428 9.16171 19.3812 9.77166 19.9911C10.3816 20.6011 11.32 20.6517 11.8676 20.1041Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.84242 20.0025C8.38999 19.455 8.33942 18.5166 7.72947 17.9066C7.11951 17.2967 6.18114 17.2461 5.63356 17.7937C5.08599 18.3413 5.13656 19.2796 5.74652 19.8896C6.35648 20.4995 7.29484 20.5501 7.84242 20.0025Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.45033 22.5924C7.9979 22.0448 7.94733 21.1064 7.33738 20.4965C6.72742 19.8865 5.78905 19.8359 5.24147 20.3835C4.6939 20.9311 4.74447 21.8695 5.35443 22.4794C5.96439 23.0894 6.90275 23.14 7.45033 22.5924Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.7599 21.4898C10.3075 20.9423 10.2569 20.0039 9.64695 19.3939C9.03699 18.784 8.09862 18.7334 7.55104 19.281C7.00347 19.8286 7.05404 20.7669 7.664 21.3769C8.27396 21.9868 9.21232 22.0374 9.7599 21.4898Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.2482 22.4239C12.7958 21.8763 12.7452 20.938 12.1352 20.328C11.5253 19.7181 10.5869 19.6675 10.0393 20.2151C9.49175 20.7626 9.54232 21.701 10.1523 22.311C10.7622 22.9209 11.7006 22.9715 12.2482 22.4239Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    ) : (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M23.0001 10.2909V11.0126C22.3596 11.2045 21.6541 11.2825 20.8543 11.224C20.8738 10.9541 20.8478 10.7135 20.7697 10.538C20.7177 10.4177 20.6234 10.3006 20.5617 10.1803C20.3016 9.67637 20.5031 9.30573 20.6722 8.87331C20.6787 8.85705 20.6852 8.8408 20.6917 8.82129H21.5305C22.3369 8.82129 23.0001 9.48455 23.0001 10.2909Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.908 8.82129C19.8202 9.20494 19.7292 9.55283 19.2935 9.78041C19.1732 9.84219 19.0302 9.88771 18.9164 9.95598C18.6628 10.112 18.4254 10.4567 18.2466 10.8728C17.1087 10.8468 16 11.0126 16 11.0126V10.2909C16 9.48455 16.6633 8.82129 17.4696 8.82129H19.908Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23 11.0122V17.7326C23 18.5422 22.3367 19.2022 21.5304 19.2022H17.4696C16.6633 19.2022 16 18.5422 16 17.7326V11.0122C16 11.0122 17.1087 10.8464 18.2466 10.8724C17.8987 11.669 17.7622 12.7289 18.1426 13.2296C18.3117 13.4507 18.5295 13.6002 18.7668 13.6717C19.0042 13.7465 19.2675 13.753 19.5309 13.6652C20.2397 13.4377 20.8021 12.1534 20.8542 11.2235C21.654 11.2821 22.3595 11.204 23 11.0122Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.246 7.51123C20.1126 8.00868 20.0054 8.42484 19.9501 8.64918C19.9338 8.7077 19.9208 8.76622 19.9078 8.82474H16.9524C16.5883 8.82474 16.2957 8.52888 16.2957 8.16799C16.2957 7.98917 16.3704 7.82335 16.4875 7.70306C16.6045 7.58601 16.7703 7.51123 16.9524 7.51123H20.246Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.7074 8.16457C22.7074 8.34339 22.6327 8.5092 22.5156 8.6295C22.3953 8.74655 22.2295 8.82133 22.0507 8.82133H20.6917C20.7957 8.55147 20.9745 8.07028 21.1761 7.50781H22.0507C22.4116 7.50781 22.7074 7.80368 22.7074 8.16457Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22.3924 4.04853C22.2169 4.6045 21.6316 6.25615 21.1764 7.50789H20.2466C20.5945 6.19762 21.1147 4.30213 21.3 3.70715C21.3 3.70715 21.4626 2.82605 22.1128 3.03088C22.7598 3.23571 22.3924 4.04853 22.3924 4.04853Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.1762 7.51123C20.9746 8.0737 20.7958 8.55489 20.6918 8.82474H19.9082C19.9212 8.76622 19.9342 8.7077 19.9505 8.64918C20.0057 8.42484 20.113 8.00868 20.2463 7.51123H21.1762Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8541 11.224C20.4282 11.1947 19.9795 11.1232 19.4983 11.0126C19.1179 10.9249 18.679 10.8826 18.2466 10.8728C18.4254 10.4567 18.6627 10.112 18.9163 9.95598C19.0301 9.88771 19.1732 9.84219 19.2935 9.78041C19.7292 9.55283 19.8202 9.20494 19.908 8.82129H20.6915C20.685 8.8408 20.6785 8.85705 20.672 8.87331C20.503 9.30573 20.3014 9.67637 20.5615 10.1803C20.6233 10.3006 20.7175 10.4177 20.7696 10.538C20.8476 10.7135 20.8736 10.9541 20.8541 11.224Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.8542 11.2237C20.8022 12.1536 20.2398 13.4378 19.531 13.6654C19.2676 13.7532 19.0043 13.7467 18.7669 13.6719C18.5296 13.6004 18.3117 13.4508 18.1427 13.2297C17.7623 12.729 17.8988 11.6691 18.2467 10.8726C18.6791 10.8823 19.1181 10.9246 19.4985 11.0124C19.9796 11.1229 20.4283 11.1944 20.8542 11.2237Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.1504 10.158C13.3857 10.1952 13.6329 10.2464 13.8084 10.4279L13.8124 10.4325C15.7944 12.4428 14.8093 15.0626 14.3069 15.9514C13.8004 16.8029 13.5651 17.9802 12.9231 18.6829C12.3368 19.3297 11.2082 19.5298 10.4346 19.5298C9.11059 19.5298 8.15348 18.9249 7.23227 17.8965C6.73777 17.3474 6.67396 17.2962 6.39481 16.5005C6.17946 15.9328 6.04786 15.3278 6 14.7089V13.4386C6.02792 13.0384 6.11166 12.6475 6.24725 12.2752C6.53438 11.5772 6.62212 11.5772 7.08472 11.1212C8.15348 10.0603 9.00291 9.52979 10.4346 9.52979C10.5781 9.52979 10.7217 9.54375 10.8613 9.57167L13.0547 10.1673L13.1504 10.158Z"
                fill={appleColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M11.0417 10.9953H12C12.2771 10.9813 12.5542 10.9112 12.8032 10.785C13.0522 10.6589 13.2729 10.4813 13.4467 10.2664C14.1513 9.3785 13.9822 8 13.9822 8C12.0141 8 11.3236 8.91122 11.0981 9.72897C10.99 10.1449 10.9713 10.5748 11.0417 11V10.9953Z"
                fill={leafColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28 22.0649V24.0396C28 25.6728 22.1794 27 15.0014 27C7.82344 27 2 25.6728 2 24.0396V22.0649C2 21.2595 3.40666 20.5347 5.68741 20H24.3155C26.5933 20.5347 28 21.2595 28 22.0649Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28 22C28 22.3526 27.7395 22.6888 27.259 23.0022C25.4732 24.1676 20.6599 25 15.0014 25C9.34298 25 4.52388 24.1676 2.74096 23.0022C2.26049 22.6888 2 22.3493 2 22C2 21.1839 3.40666 20.4494 5.68741 19.9075C8.04631 19.3493 11.3488 19 15.0014 19C18.6541 19 21.9537 19.3493 24.3155 19.9075C26.5933 20.4494 28 21.1839 28 22Z"
                fill={plateColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M23.6582 18.6385V22.2208L20.419 21.6292V19.4579L19.4665 18.5912L18.2507 17.4878L23.6582 18.6385Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.8799 17.2627V20.845C24.8799 21.3627 24.4244 21.8389 23.6582 22.2205V18.6382C24.4244 18.2566 24.8799 17.7804 24.8799 17.2627Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.419 19.4576V23.0399C19.9457 23.0873 19.4487 23.1109 18.9399 23.1109C15.6594 23.1109 13 22.0963 13 20.845V17.2627C13 17.9934 13.9052 18.6412 15.3103 19.0553C16.3161 19.3511 17.5733 19.5286 18.9399 19.5286C19.4487 19.5286 19.9457 19.505 20.419 19.4576Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M24.8799 17.263C24.8799 17.7806 24.4243 18.2569 23.6582 18.6385L18.2507 17.4878L19.4665 18.5912L20.419 19.4579C19.9457 19.5052 19.4487 19.5289 18.9399 19.5289C17.5733 19.5289 16.3161 19.3514 15.3103 19.0556C13.9052 18.6415 13 17.9936 13 17.263C13 16.9228 13.1982 16.5974 13.5561 16.3075C14.4998 15.5354 16.5557 15 18.9399 15C19.5375 15 20.1143 15.0325 20.6586 15.0947C23.102 15.3786 24.8799 16.2424 24.8799 17.263Z"
                fill={cheeseColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.98409 15.0948L2.98416 16.0949C2.98416 16.0949 5.43439 15.8724 7.98413 20.0947L8.24316 19.7346C8.24316 19.7346 6.98411 15.5948 2.98409 15.0948Z"
                fill={spoonColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.82815 17.4973L7.76937 17.3175C8.03896 17.2517 8.29802 17.1308 8.51888 16.9602C8.73974 16.7895 8.92326 16.5737 9.05364 16.33C9.57911 15.3257 9.15433 14.0034 9.15433 14.0034C7.22114 14.3727 6.7139 15.3973 6.64588 16.2428C6.61781 16.6716 6.68003 17.0974 6.82903 17.5019L6.82815 17.4973Z"
                fill={leafColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.9284 25.8224C15.4759 25.2748 15.4254 24.3364 14.8154 23.7265C14.2054 23.1165 13.2671 23.0659 12.7195 23.6135C12.1719 24.1611 12.2225 25.0994 12.8325 25.7094C13.4424 26.3194 14.3808 26.3699 14.9284 25.8224Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.7487 23.7267C15.2962 23.1791 15.2457 22.2407 14.6357 21.6308C14.0258 21.0208 13.0874 20.9702 12.5398 21.5178C11.9922 22.0654 12.0428 23.0037 12.6528 23.6137C13.2627 24.2237 14.2011 24.2742 14.7487 23.7267Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.9577 18.1388C12.5052 17.5912 12.4547 16.6528 11.8447 16.0429C11.2347 15.4329 10.2964 15.3823 9.7488 15.9299C9.20122 16.4775 9.25179 17.4159 9.86175 18.0258C10.4717 18.6358 11.4101 18.6863 11.9577 18.1388Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.6862 19.9903C14.2337 19.4428 14.1832 18.5044 13.5732 17.8944C12.9633 17.2845 12.0249 17.2339 11.4773 17.7815C10.9297 18.3291 10.9803 19.2674 11.5903 19.8774C12.2002 20.4873 13.1386 20.5379 13.6862 19.9903Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.973 21.8487C14.5206 21.3012 14.47 20.3628 13.8601 19.7528C13.2501 19.1429 12.3118 19.0923 11.7642 19.6399C11.2166 20.1874 11.2672 21.1258 11.8771 21.7358C12.4871 22.3457 13.4255 22.3963 13.973 21.8487Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.95277 23.7267C10.5003 23.1791 10.4498 22.2407 9.83982 21.6308C9.22986 21.0208 8.29149 20.9702 7.74392 21.5178C7.19634 22.0654 7.24691 23.0037 7.85687 23.6137C8.46683 24.2237 9.40519 24.2742 9.95277 23.7267Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.432 24.5904C12.9796 24.0429 12.929 23.1045 12.3191 22.4945C11.7091 21.8846 10.7707 21.834 10.2232 22.3816C9.67559 22.9291 9.72616 23.8675 10.3361 24.4775C10.9461 25.0874 11.8844 25.138 12.432 24.5904Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.95057 18.6959C10.4981 18.1483 10.4476 17.21 9.83762 16.6C9.22766 15.99 8.28929 15.9395 7.74172 16.487C7.19414 17.0346 7.24471 17.973 7.85467 18.5829C8.46463 19.1929 9.403 19.2435 9.95057 18.6959Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.8676 20.1041C12.4151 19.5565 12.3646 18.6182 11.7546 18.0082C11.1447 17.3982 10.2063 17.3477 9.65871 17.8952C9.11113 18.4428 9.16171 19.3812 9.77166 19.9911C10.3816 20.6011 11.32 20.6517 11.8676 20.1041Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.84242 20.0025C8.38999 19.455 8.33942 18.5166 7.72947 17.9066C7.11951 17.2967 6.18114 17.2461 5.63356 17.7937C5.08599 18.3413 5.13656 19.2796 5.74652 19.8896C6.35648 20.4995 7.29484 20.5501 7.84242 20.0025Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.45033 22.5924C7.9979 22.0448 7.94733 21.1064 7.33738 20.4965C6.72742 19.8865 5.78905 19.8359 5.24147 20.3835C4.6939 20.9311 4.74447 21.8695 5.35443 22.4794C5.96439 23.0894 6.90275 23.14 7.45033 22.5924Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.7599 21.4898C10.3075 20.9423 10.2569 20.0039 9.64695 19.3939C9.03699 18.784 8.09862 18.7334 7.55104 19.281C7.00347 19.8286 7.05404 20.7669 7.664 21.3769C8.27396 21.9868 9.21232 22.0374 9.7599 21.4898Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.2482 22.4239C12.7958 21.8763 12.7452 20.938 12.1352 20.328C11.5253 19.7181 10.5869 19.6675 10.0393 20.2151C9.49175 20.7626 9.54232 21.701 10.1523 22.311C10.7622 22.9209 11.7006 22.9715 12.2482 22.4239Z"
                fill={grapesColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

HostingAndEntertaining.propTypes = {
    brand: PropTypes.oneOf([IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN]).isRequired,
    isActive: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

HostingAndEntertaining.defaultProps = {
    isActive: false,
    width: 30,
};
